/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData model module.
 * @module model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData
 * @version 1.0
 */
class LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData {
    /**
     * Constructs a new <code>LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData</code>.
     * @alias module:model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData
     */
    constructor() { 
        
        LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData} The populated <code>LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'Blob');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('walletAddress')) {
                obj['walletAddress'] = ApiClient.convertToType(data['walletAddress'], 'String');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
            if (data.hasOwnProperty('transactionType')) {
                obj['transactionType'] = ApiClient.convertToType(data['transactionType'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['walletAddress'] && !(typeof data['walletAddress'] === 'string' || data['walletAddress'] instanceof String)) {
            throw new Error("Expected the field `walletAddress` to be a primitive type in the JSON string but got " + data['walletAddress']);
        }

        return true;
    }


}



/**
 * @member {Blob} key
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['key'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['accountNo'] = undefined;

/**
 * @member {String} walletAddress
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['walletAddress'] = undefined;

/**
 * @member {Number} tokenType
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['tokenType'] = undefined;

/**
 * @member {Number} value
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['value'] = undefined;

/**
 * @member {Number} transactionType
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['transactionType'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['createdAt'] = undefined;

/**
 * @member {Number} status
 */
LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData.prototype['status'] = undefined;






export default LogControllerDtoTransactionAttemptLogListTransactionAttemptLogListData;

